var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcSocTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "#36F6FF",
    fillOpacity: 0.5,
    stroke: "#36F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2372 17.0644C15.07 14.9478 18.2918 13.5523 19.9027 12.878C24.5076 10.9527 25.4632 10.6184 26.0874 10.607C26.2247 10.6048 26.5303 10.6389 26.7297 10.801C26.8954 10.9378 26.9421 11.1227 26.9654 11.2525C26.9861 11.3822 27.0146 11.6777 26.9913 11.9085C26.7426 14.5439 25.6627 20.9391 25.1136 23.8909C24.8831 25.1399 24.4247 25.5586 23.9818 25.5995C23.0184 25.6886 22.288 24.9599 21.3557 24.3456C19.8975 23.3839 19.074 22.7855 17.6573 21.8472C16.0205 20.7628 17.0823 20.1667 18.0147 19.1928C18.2581 18.9378 22.5004 15.059 22.5807 14.7071C22.591 14.6631 22.6014 14.4991 22.503 14.4126C22.4072 14.3259 22.2647 14.3556 22.1611 14.379C22.0135 14.4123 19.6852 15.9613 15.1684 19.0256C14.508 19.4824 13.9097 19.705 13.371 19.6933C12.7805 19.6805 11.641 19.3568 10.7941 19.0803C9.7581 18.741 8.93192 18.5615 9.00443 17.9852C9.04069 17.6852 9.45249 17.3782 10.2372 17.0644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcSocTel);
export default __webpack_public_path__ + "static/media/tc_soc_tel.ab94f5a668bf085b9aac3206116bcb22.svg";
export { ForwardRef as ReactComponent };